module.exports = __webpack_public_path__ + "media/images/emblems/Schiers_wappen-f399ff23363d5efd01ded719620daaca.svg";